export default {
  labels: {
    field: 'Поле'
  },

  directions: {
    ASC: 'По возрастанию',
    DESC: 'По убыванию'
  }
}
